import axios, { AxiosInstance } from "axios";

let instance: AxiosInstance | null = null;

export function createApiClient(): AxiosInstance {
    if (instance) {
        return instance;
    }

    instance = axios.create({
        withCredentials: true,
    });

    instance.interceptors.response.use(
        (res) => res,
        (error) => {
            if (error.response?.status === 401) {
                console.warn("Unauthorized request:", error.config?.url);
            }
            return Promise.reject(error);
        },
    );

    return instance;
}
